import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Mission_Update_Mutation = graphql(`
  mutation MissionForm_Mission_Update(
    $id: Id!
    $update: MissionInput!
    $versionData: VersionDataInput
  ) {
    updateMission(id: $id, update: $update, versionData: $versionData) {
      _id
    }
  }
`);

export type MissionForm_Mission_Update_Result = ResultOf<
  typeof MissionForm_Mission_Update_Mutation
>;

export const useUpdateMissionMutation = () =>
  useGraphQLMutation(MissionForm_Mission_Update_Mutation);
